import {
  DashboardView,
  ProjectTemplateSummary
} from '@experiment-management-shared/types';
import { DASHBOARD_VIEW_AUTOSAVE_DELAY } from '@projects/components/EMDashboardPage/useDashboardAPIContext';
import { ViewItemData } from '@shared/components/ViewSelect/utils';

export const templateToProjectOptionItem = (
  template: ProjectTemplateSummary
): ViewItemData => ({
  name: template.templateName,
  isDefault: template.projectDefault,
  id: template.templateId as string
});

export const templateToWorkspaceOptionItem = (
  template: ProjectTemplateSummary
): ViewItemData => ({
  name: template.templateName,
  source: template.source,
  isDefault: template.projectDefault,
  id: template.templateId as string
});

export const shouldBeLocalTemplateSaved = (view?: DashboardView | null) => {
  if (!view?.isLocalView || !view?.lastUpdate) return false;

  const timeNow = new Date().getTime();

  return timeNow - view.lastUpdate > DASHBOARD_VIEW_AUTOSAVE_DELAY;
};
